import React from 'react';
import Avatar from '@strava/ui/Avatar';
import { LinkButton } from '@strava/ui/Button';
import Stat from '@strava/ui/Stat';
import Stats from '@strava/ui/Stats';
import { getProfileVisibility } from '../../helpers/getProfileVisibility';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';

import styles from './Details.module.scss';

const Details = () => {
  const { state, t, track } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete } = athleteData;
  const {
    name,
    location,
    avatarUrl,
    followersCount,
    followingCount,
    followUrl
  } = athlete;

  const handleFollowClick = () => {
    track({
      action: 'click',
      element: 'start_signup',
      properties: {
        profile_visibility: getProfileVisibility(athlete),
        signup_copy: 'follow_on_strava'
      }
    });
  };

  return (
    <div className={styles.details}>
      <div className={styles.athlete}>
        <Avatar name={name} src={avatarUrl} size="xlarge" type="athlete" />
        <h2 className={styles.name} data-testid="details-name">
          {name}
        </h2>
        <div className={styles.location}>{location}</div>
        <LinkButton
          className={styles.followButton}
          href={followUrl}
          variant="primary"
          onClick={handleFollowClick}
        >
          {t('follow_cta')}
        </LinkButton>
      </div>

      <Stats listClassName={styles.followStats}>
        <Stat
          value={followersCount}
          label={t('followers')}
          type="stat-xl"
          wrapperClassName={styles.stat}
          labelClassName={styles.statLabel}
        />
        <Stat
          value={followingCount}
          label={t('following')}
          type="stat-xl"
          wrapperClassName={styles.stat}
          labelClassName={styles.statLabel}
        />
      </Stats>
    </div>
  );
};

export default Details;
